module.exports = __webpack_public_path__ + "static/img/birds-hero.a7cde61e.svg";